import { FETCH_CREDITS, FETCH_FUTURE_RELEASES } from '../actions/types';

export default (state = {}, action) => {
  switch (action.type) {
    case FETCH_CREDITS:
      return { ...state, credits: action.payload };
    case FETCH_FUTURE_RELEASES:
      return { ...state, futureReleases: action.payload };
    default:
      return state;
  }
};
